// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"dc710574d3382a9eb7fb","303":"ae7bc7b724b3ccbc1cee","495":"0638b5db29b90c4bf969"}[chunkId] + ".js";
};